//src/routes/routesList.ts
import { lazy } from 'react';

export const routesList = [
    {
        path: '/login',
        exact: true,
        component: lazy(() => import('@pages/Login')),
        isPrivate: false,
        roles: ['Guest'],
    },
    {
        path: '/logout',
        exact: true,
        component: lazy(() => import('@pages/Logout')),
        isPrivate: false,
        roles: ['Guest'],
    },
    // Registration temporarily disabled
    /* {
        path: '/register',
        exact: true,
        component: lazy(() => import('@pages/Register')),
        isPrivate: false,
        roles: ['Guest'],
    }, */
    {
        path: '/forgot-password',
        exact: true,
        component: lazy(() => import('@pages/Forget')),
        isPrivate: false,
        roles: ['Guest'],
    },
    {
        path: '/reset-password',
        exact: true,
        component: lazy(() => import('@pages/ResetPassword')),
        isPrivate: false,
        roles: ['Guest'],
    },
    {
        path: '/reset-password/:userId/:token',
        exact: true,
        component: lazy(() => import('@pages/ResetPassword')),
        isPrivate: false,
        roles: ['Guest'],
    },
    {
        path: '/users',
        exact: true,
        component: lazy(() => import('@pages/User/List')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/user',
        exact: true,
        component: lazy(() => import('@pages/User/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/user/:id',
        exact: true,
        component: lazy(() => import('@pages/User/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/products',
        exact: true,
        component: lazy(() => import('@pages/Product/List')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/product',
        exact: true,
        component: lazy(() => import('@pages/Product/Enter')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/product/:id',
        exact: true,
        component: lazy(() => import('@pages/Product/Enter')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/reset:ticket',
        exact: true,
        component: lazy(() => import('@pages/ResetPassword')),
        isPrivate: false,
        roles: ['Guest'],
    },
    {
        path: '/',
        exact: true,
        component: lazy(() => import('@pages/Dashboard')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/dashboard',
        exact: true,
        component: lazy(() => import('@pages/Dashboard')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/home',
        exact: true,
        component: lazy(() => import('@pages/Dashboard')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/customer-types',
        exact: true,
        component: lazy(() => import('@pages/CustomerType/List')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/customer-type',
        exact: true,
        component: lazy(() => import('@pages/CustomerType/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/customer-type/:id',
        exact: true,
        component: lazy(() => import('@pages/CustomerType/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/animation-modes',
        exact: true,
        component: lazy(() => import('@pages/AnimationMode/List')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/animation-mode',
        exact: true,
        component: lazy(() => import('@pages/AnimationMode/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/animation-mode/:id',
        exact: true,
        component: lazy(() => import('@pages/AnimationMode/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/resolutions',
        exact: true,
        component: lazy(() => import('@pages/Resolution/List')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/resolution',
        exact: true,
        component: lazy(() => import('@pages/Resolution/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/resolution/:id',
        exact: true,
        component: lazy(() => import('@pages/Resolution/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/genres',
        exact: true,
        component: lazy(() => import('@pages/Genre/List')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/genre',
        exact: true,
        component: lazy(() => import('@pages/Genre/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/genre/:id',
        exact: true,
        component: lazy(() => import('@pages/Genre/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/product-types',
        exact: true,
        component: lazy(() => import('@pages/ProductType/List')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/product-type',
        exact: true,
        component: lazy(() => import('@pages/ProductType/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/product-type/:id',
        exact: true,
        component: lazy(() => import('@pages/ProductType/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/generative-videos',
        exact: true,
        component: lazy(() => import('@pages/GenerativeVideo/List')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/generative-video',
        exact: true,
        component: lazy(() => import('@pages/GenerativeVideo/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/generative-video/:id',
        exact: true,
        component: lazy(() => import('@pages/GenerativeVideo/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/audio-synchronizations',
        exact: true,
        component: lazy(() => import('@pages/AudioSynchronization/List')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/audio-synchronization',
        exact: true,
        component: lazy(() => import('@pages/AudioSynchronization/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/audio-synchronization/:id',
        exact: true,
        component: lazy(() => import('@pages/AudioSynchronization/Enter')),
        isPrivate: true,
        roles: ['Administrator'],
    },
    {
        path: '/projects',
        exact: true,
        component: lazy(() => import('@pages/Project/List')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/project',
        exact: true,
        component: lazy(() => import('@pages/Project/Enter')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/project/:id',
        exact: true,
        component: lazy(() => import('@pages/Project/Enter')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/project/:id/storyboard',
        exact: true,
        component: lazy(() => import('@pages/Project/Enter')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/order',
        exact: true,
        component: lazy(() => import('@pages/Order/List')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/my-account',
        exact: true,
        component: lazy(() => import('@pages/User/MyAccount')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/confirm-order',
        exact: true,
        component: lazy(() => import('@pages/Order/Confirm')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/login/:userId/:token',
        exact: true,
        component: lazy(() => import('@pages/Login')),
        isPrivate: false,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/login/:emailVerified',
        exact: true,
        component: lazy(() => import('@pages/Login')),
        isPrivate: false,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/plans',
        exact: true,
        component: lazy(() => import('@pages/Plans')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
    {
        path: '/my-account',
        exact: true,
        component: lazy(() => import('@pages/User/MyAccount')),
        isPrivate: true,
        roles: ['Customer', 'Administrator'],
    },
];
